import { RouteConfig } from 'react-router-config';
import { DownloadCenterRouter } from '../../pages/download-center';

export const DOWNLOAD_ROUTE: RouteConfig[] = [
  {
    path: '/download/download-center',
    component: DownloadCenterRouter,
    // routes: [
    // ],
  },
];
